import { NextRouter } from 'next/router';

import {
  DEFAULT_DIRECTION,
  DEFAULT_LOCALE,
  DIRECTION_LOOKUP,
  SiteLocale,
} from 'constants/i18n.constants';

type NextRouterLocaleProps = Pick<NextRouter, 'locale' | 'defaultLocale'>;
type DefaultLocale = Pick<NextRouter, 'defaultLocale'>;

export const getLocale = ({ locale, defaultLocale }: NextRouterLocaleProps) =>
  (locale ?? defaultLocale ?? DEFAULT_LOCALE) as SiteLocale;

export const getDefaultLocale = ({ defaultLocale }: DefaultLocale) =>
  (defaultLocale ?? DEFAULT_LOCALE) as SiteLocale;

export const getDirection = (locale?: string) =>
  locale ? (DIRECTION_LOOKUP[locale] ?? DEFAULT_DIRECTION) : DEFAULT_DIRECTION;
